export default "__VITE_ASSET__A7VnVsFB__"